var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('h2',[_vm._v("User: "+_vm._s(_vm.user.username))]),_vm._v(" "),_c('p',[_vm._v("ID: "+_vm._s(_vm.user.id))]),_vm._v(" "),_c('img',{attrs:{"src":_vm.userAvatar}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d6fd850","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = null
// module chunks = 